import { ChevronRight } from 'lucide-react';
import { verdictTone } from './semantics';
import type { CommentarySection } from './types';

interface CommentaryCardProps {
  commentary: CommentarySection;
}

export function CommentaryCard({ commentary }: CommentaryCardProps) {
  const tone = verdictTone(commentary.verdict);
  const hasPoints = (commentary.key_points?.length ?? 0) > 0;

  return (
    <article
      className={`rounded-xl border ${tone.border} bg-white p-4 hover:shadow-md transition-shadow flex flex-col h-full`}
    >
      {/* Header: title + verdict badge */}
      <div className="flex items-start justify-between gap-2 mb-2">
        <h4 className="text-sm font-semibold text-neutral-900 leading-snug">{commentary.title}</h4>
        <span
          className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-bold shrink-0 ${tone.pill}`}
          aria-label={`Verdict: ${commentary.verdict}`}
        >
          {commentary.verdict}
        </span>
      </div>

      {/* Summary */}
      <p className="text-xs text-neutral-600 leading-relaxed flex-1">{commentary.summary}</p>

      {/* Key points */}
      {hasPoints && (
        <ul
          className="space-y-1.5 border-t border-neutral-100 pt-3 mt-3"
          role="list"
          aria-label="Key points"
        >
          {commentary.key_points.map((pt, i) => (
            <li key={i} className="flex items-start gap-1.5 text-xs text-neutral-600">
              <ChevronRight
                className={`h-3 w-3 mt-0.5 shrink-0 ${tone.icon}`}
                aria-hidden="true"
              />
              {pt}
            </li>
          ))}
        </ul>
      )}
    </article>
  );
}
